import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { CompaniesFormFields, CompaniesFormValues } from '../schemas';
import { CompaniesTabs } from '../types';

interface CompanySearchMessageProps {
    companiesCount: number;
    searchValue: string;
    hasNextPage: boolean;
    isFetching: boolean;
    activeTab: CompaniesTabs;
    selectedCompanies: CompaniesFormValues;
}
export const getCompanySearchMessage = ({
    companiesCount,
    searchValue,
    hasNextPage,
    isFetching,
    activeTab,
    selectedCompanies,
}: CompanySearchMessageProps) => {
    const searchedCompaniesCount = Object.entries(selectedCompanies).filter(
        ([_, company]) =>
            (company.linkAsCompany || company.linkAsTravelAgency) &&
            company.name.toLowerCase().includes(searchValue.toLowerCase())
    ).length;

    if (searchValue === '' || isFetching) return null;

    if (activeTab === CompaniesTabs.AllProfiles) {
        if (companiesCount === 0) {
            return lt(TextKey.RoutingRulesFormCompaniesDialogNoResultsMessage);
        }
        return hasNextPage
            ? lt(TextKey.RoutingRulesFormCompaniesDialogLargeResultsMessage)
            : lt(TextKey.RoutingRulesFormCompaniesDialogResultsMessage, { count: companiesCount });
    }
    return searchedCompaniesCount === 0
        ? lt(TextKey.RoutingRulesFormCompaniesDialogNoResultsMessage)
        : lt(TextKey.RoutingRulesFormCompaniesDialogResultsMessage, { count: searchedCompaniesCount });
};

export const filterCompaniesByTypes = (
    companies: CompaniesFormValues,
    types: (CompaniesFormFields.LinkAsCompany | CompaniesFormFields.LinkAsTravelAgency)[]
) => Object.entries(companies).filter(([_, company]) => types.some((type) => company[type]));

export const getSelectedCompanyIds = ({
    companiesEnabled,
    selectedCompanies,
    types,
}: {
    companiesEnabled: boolean;
    selectedCompanies: CompaniesFormValues;
    types: (CompaniesFormFields.LinkAsCompany | CompaniesFormFields.LinkAsTravelAgency)[];
}) => (companiesEnabled ? filterCompaniesByTypes(selectedCompanies, types).map(([id]) => id) : null);

export const getSelectedCompaniesCount = (selectedCompanies: CompaniesFormValues) =>
    filterCompaniesByTypes(selectedCompanies, [CompaniesFormFields.LinkAsCompany]).length +
    filterCompaniesByTypes(selectedCompanies, [CompaniesFormFields.LinkAsTravelAgency]).length;
